module.exports = __webpack_public_path__ + "img/costal-6-4.af5995a6.jpg";